import { FC, useContext } from 'react';

import cn from 'classnames';

import { ActionSchedule } from 'components';
import { LocalizationContext } from 'localization';
import { ETariffType } from 'types';

import { SalesTime } from '../SalesTime';
import s from '../Tariff.module.scss';
import { ITariffScheduleSectionProps } from './interfaces';

export const TariffScheduleSection: FC<ITariffScheduleSectionProps> = ({
  control,
  tariffType,
  trigger,
  setValue,
  isDirty,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s['form-block']}>
      <div className={cn(s.fields, s.schedule)}>
        <div className={s['working-time']}>
          <ActionSchedule
            control={control}
            trigger={trigger}
            title={
              tariffType === ETariffType.FIXED
                ? 'tariff.schedule_payment'
                : 'tariff.schedule'
            }
            bordered
          />
        </div>
        {(tariffType === 'PACKET' || tariffType === 'PAUSABLE') && (
          <div className={s['sales-time']}>
            <span className={s['sales-title']}>{t('tariff.salesTime')}</span>
            <SalesTime
              control={control}
              setValue={setValue}
              trigger={trigger}
              isFormDirty={isDirty}
            />
          </div>
        )}
      </div>
    </div>
  );
};
